var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idb-block"},[_c('div',{staticClass:"idb-block-title"},[_c('h2',[_vm._t("title",function(){return [_c('span',[_vm._v("No Title specified.")])]})],2)]),_c('div',{staticClass:"idb-block-content"},[_vm._t("default",function(){return [_c('p',[_vm._v("Content has not been specified.")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }